import axios from "axios";
import router from "@/router";
// import store from "@/store";
import { Message } from "element-ui";
import { getToken, removeToken } from "./auth";
// import md5 from "js-md5";
const currentUrl = window.location.href;
var pos = window.location.pathname
window.baseUrl = currentUrl.substring(0, currentUrl.indexOf(pos))
const _axios = axios.create({
  // baseURL: process.env.NODE_ENV === 'production' ? window.g.baseUrl + '/api/app' : '/api/app'
  baseURL: "/api/app",
    // timeout: 5000
});

// // 请求拦截器配置
_axios.interceptors.request.use(
    (config) => {
        // 获取token
        const token = getToken();
        if (token) {
            // const userId = JSON.parse(window.localStorage.getItem("user")).userId;
            if (token != 'null' && token != 'success') {
                config.headers.token = token;
            }
            // config.headers.userId = md5(userId);
        }
        config.headers.type = 0;
        return config;
    },
    (error) => Promise.reject(error)
);

// 响应拦截器配置
_axios.interceptors.response.use(
    (response) => {
        if (response.data.status === 401 || response.data.status === 402) {
            // 删除token

            removeToken();
            // localStorage.removeItem("user");
            // localStorage.removeItem("routes");
            // localStorage.removeItem("roles");
            // store.commit("setRoutes", []);
            // // 跳转至登录
            // if (response.data.status === 401) {
            //     router.replace("/login?type=overdue");
            // } else {
            //     router.replace("/login?type=repeat");
            // }

            return;
        }

        if (response.data.status !== 0) {
            // Message.error(response.data.desc);
        }

        return response;
    },
    (error) => {
        console.log(error);
        if (error.response.status === 500) {
            Message.error(error.response.data.desc);
        } else if (error.response.status === 504) {
            Message.error("请求超时，请稍后重试");
        } else {
            Message.error("服务异常，请联系管理员");
        }
        Promise.reject(error);
    }
);

export default _axios;